export default __webpack_public_path__ + "static/media/vf-unassociate.b4578966.svg";